import {
  StructuredTableKind,
  StructuredTableRow,
  UnknownStructuredTable,
} from 'notebook/structured-tables/StructuredTableConstants';
import {EvaluatedCell} from 'notebook/tables/excess/EvaluationConstants';

import {getStructuredTableAdapters} from '../StructuredTableAdapters';
import buildRowUiData from './buildRowUiData';
import {getLiveRowMetadataFromRowUpdater} from './getLiveRowMetadataFromRowUpdater';

/**
 * Returns a list of booleans corresponding the rowIndex of a given table,
 * displaying true if a row is archived and false if a row is not archived.
 *
 * @param structuredTable - the StructuredTable we're checking for changes
 * @param computedTable - the evaluated version of the StructuredTable
 */
export default function getArchivedRows(
  structuredTable: UnknownStructuredTable,
  computedTable: Array<Array<EvaluatedCell>>,
  structuredTableRowsBatch?: Array<StructuredTableRow<unknown>>
): Array<boolean> {
  const structuredTableRows = structuredTableRowsBatch || structuredTable.rows;
  // Lookup tables do not have a submit button
  const isLookupTable = structuredTable.kind === StructuredTableKind.LOOKUP;
  if (isLookupTable) {
    return Array(structuredTableRows.length).fill(false);
  }

  // Pull in live data to check for archival reasons
  const adapter = getStructuredTableAdapters()[structuredTable.kind];
  const primarySamplesByRowIds = adapter.getPrimarySamples(
    structuredTable,
    computedTable,
    structuredTableRowsBatch
  );
  const liveRowMetadataByRow = structuredTableRows.map((row, i) =>
    getLiveRowMetadataFromRowUpdater({
      row,
      primarySamples: primarySamplesByRowIds[row.rowId],
      adapter,
      columns: structuredTable.columns,
    })
  );
  const liveRowUiData = buildRowUiData(structuredTable, liveRowMetadataByRow, structuredTableRowsBatch);

  // We check to see if the row contains an archivePurpose, evaluating to true if
  // it does and false if it does not.
  return structuredTableRows.map((_, rowIndex) => liveRowUiData[rowIndex].archivePurpose != null);
}
